import { Link } from 'react-router-dom'
import { RequestStatusBadge, CategoryBadge } from '../../../../shared/ui/Badge'
import type { QuotesSummaryResponse } from '../../../../shared/api/quotesSelection.api'

interface Props {
  request: QuotesSummaryResponse['request']
}

function formatDate(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' })
}

function daysLeft(iso: string | null): number | null {
  if (!iso) return null
  const d = new Date(iso)
  const now = new Date()
  return Math.ceil((d.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}

export function QuotesSelectionHeader({ request }: Props) {
  const dl = daysLeft(request.deadline)
  const dlBurning = dl != null && dl <= 3
  return (
    <div className="space-y-3">
      <nav className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
        <Link to="/requests" className="hover:text-gray-700 dark:hover:text-gray-200">
          Заявки
        </Link>
        <span>›</span>
        <Link
          to={`/requests/${request.id}`}
          className="hover:text-gray-700 dark:hover:text-gray-200 truncate max-w-[220px]"
        >
          {request.clientName || request.requestNumber}
        </Link>
        <span>›</span>
        <span className="text-gray-700 dark:text-gray-200">Выбор квот</span>
      </nav>

      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate">
              {request.clientName || '—'}
            </h1>
            <CategoryBadge category={request.clientCategory} />
            <RequestStatusBadge status={request.status} />
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Менеджер: {request.managerName || '—'} · {request.positionsCount} позиций
            {request.matrices.length > 0 && <> · {request.matrices.join(', ')}</>}
          </p>
        </div>

        <div className="text-right shrink-0">
          <div
            className={`text-sm font-medium ${
              dlBurning ? 'text-red-600 dark:text-red-400' : 'text-gray-700 dark:text-gray-200'
            }`}
          >
            Дедлайн: {formatDate(request.deadline)}
            {dl != null && dl >= 0 && (
              <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">({dl} дн.)</span>
            )}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Создана: {formatDate(request.createdAt)}
          </div>
        </div>
      </div>
    </div>
  )
}
